/**
 * @flow
 */
import {Action, Reducer} from 'redux';
import type {DataQueryInfo} from '../../types/api-types'
import type {Dispatch} from 'react-beautiful-dnd/src/state/store-types';

export interface DataViewState {
  rows: Object[];
  totalCount: number;
  queryInfo: DataQueryInfo;
  openConfirm: boolean;
  openEdit: boolean;
  editMode: 'add' | 'edit';
  editData: Object;
  showSearch: boolean;
}

export interface DataViewAction extends Action {
  rows?: Object[];
  totalCount?: number;
  queryInfo?: DataQueryInfo;
  openConfirm?: boolean;
  openEdit?: boolean;
  editMode?: 'add' | 'edit';
  editData?: Object;
  showSearch?: boolean;
}

const createDataReducer: Reducer<DataViewState, DataViewAction> = (actionKey: string) => {
  return (state = {}, action) => {
    const {type, queryInfo, ...props} = action; // dispatch는 Reducer에 action을 알리는 것이다.
    if(type === `${actionKey}_RESET`) {
      return {};
    } else if(type === actionKey) {
      // dispatch로 보낸 타입과 actionKey를 비교하여 payload에 넘겨준 값을 props로 상태 변화 한다.
      return {...state, ...props, queryInfo: {...state?.queryInfo, ...queryInfo}};
    } else {
      return state;
    }
  }
};

export const companyDataReducer: Reducer<DataViewState, DataViewAction> = createDataReducer('COMPANIES_UPDATE');
export const branchDataReducer: Reducer<DataViewState, DataViewAction> = createDataReducer('BRANCHES_UPDATE');
export const groupDataReducer: Reducer<DataViewState, DataViewAction> = createDataReducer('GROUPS_UPDATE');
export const userDataReducer: Reducer<DataViewState, DataViewAction> = createDataReducer('USERS_UPDATE');
export const deviceDataReducer: Reducer<DataViewState, DataViewAction> = createDataReducer('DEVICES_UPDATE');
export const deviceTypeDataReducer: Reducer<DataViewState, DataViewAction> = createDataReducer('DEVICE_TYPES_UPDATE');
export const connectDataReducer: Reducer<DataViewState, DataViewAction> = createDataReducer('CONNECT_UPDATE');
export const dashboardListReducer: Reducer<DataViewState, DataViewAction> = createDataReducer('DASHBOARD_LIST_UPDATE');
export const dashboardPatientsListReducer: Reducer<DataViewState, DataViewAction> = createDataReducer('DASHBOARD_PATIENTS_LIST_UPDATE');
export const dashboardNotiReducer: Reducer<DataViewState, DataViewAction> = createDataReducer('DASHBOARD_NOTI_UPDATE');
export const notificationDataReducer: Reducer<DataViewState, DataViewAction> = createDataReducer('NOTIFICATION_DATA_UPDATE');
export const activityLogReducer: Reducer<DataViewState, DataViewAction> = createDataReducer('ACTIVITY_LOG_UPDATE');
export const loginLogReducer: Reducer<DataViewState, DataViewAction> = createDataReducer('LOGIN_LOG_UPDATE');
export const badDataLogReducer: Reducer<DataViewState, DataViewAction> = createDataReducer('BAD_DATA_LOG_UPDATE');
export const errorLogReducer: Reducer<DataViewState, DataViewAction> = createDataReducer('ERROR_LOG_UPDATE');
export const demoRequestsReducer: Reducer<DataViewState, DataViewAction> = createDataReducer('DEMO_REQUESTS_UPDATE');

export function clearAllSettingsData(dispatch: Dispatch) {
  dispatch({type: 'COMPANIES_UPDATE_RESET'});
  dispatch({type: 'BRANCHES_UPDATE_RESET'});
  dispatch({type: 'GROUPS_UPDATE_RESET'});
  dispatch({type: 'USERS_UPDATE_RESET'});
  dispatch({type: 'DEVICES_UPDATE_RESET'});
  dispatch({type: 'DEVICE_TYPES_UPDATE_RESET'});
  dispatch({type: 'CONNECT_UPDATE_RESET'});
  dispatch({type: 'DASHBOARD_LIST_UPDATE_RESET'});
  dispatch({type: 'DASHBOARD_PATIENTS_LIST_UPDATE_UPDATE_RESET'});
  dispatch({type: 'DASHBOARD_NOTI_UPDATE_RESET'});
  dispatch({type: 'NOTIFICATION_DATA_UPDATE_RESET'});
  dispatch({type: 'ACTIVITY_LOG_UPDATE_RESET'});
  dispatch({type: 'LOGIN_LOG_UPDATE_RESET'});
  dispatch({type: 'BAD_DATA_LOG_UPDATE_RESET'});
  dispatch({type: 'ERROR_LOG_UPDATE_RESET'});
  dispatch({type: 'DEMO_REQUESTS_UPDATE_RESET'});
}
